<template>
  <v-row>
    <v-dialog
      persistent
      transition="scale-transition"
      :max-width="$vuetify.breakpoint.xsOnly ? '90%' : '350'"
      v-model="component.dialogPermissionPrint"
    >
      <v-card class="mx-auto" outlined>
        <v-container>
          <v-row justify="center">
            <v-card-title class="title text-center">{{ confirmationMessage }}</v-card-title>
          </v-row>
          <v-row justify="center">
            <v-card-actions class="buttons-container">
              <v-btn
                :block="$vuetify.breakpoint.xsOnly"
                class="action-button red darken-4 white--text"
                @click="close"
              >
                Não
              </v-btn>
              <v-btn
                :block="$vuetify.breakpoint.xsOnly"
                class="action-button success"
                @click="printDocument"
              >
                Sim
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { INVOICE_TYPE, NOTE_MODEL_TYPE } from "@/enums/invoiceType";

export default {
  props: {
    component: Object,
  },
  components: {},

  computed: {
    documentLabel() {
      switch (this.component.invoiceType) {
        case INVOICE_TYPE.NFE:
          return NOTE_MODEL_TYPE.NFE;
        case INVOICE_TYPE.NFCE:
          return NOTE_MODEL_TYPE.NFCE;
        default:
          return "documento";
      }
    },

    confirmationMessage() {
      return `Deseja visualizar a ${this.documentLabel}?`;
    },
  },

  methods: {
    printDocument() {
      window.open(this.component.nfcePrint);
      this.component.saleSuccess = false;
      this.component.close();
    },

    close() {
      this.component.saleSuccess = false;
      this.component.close();
    },
  },
};
</script>
<style scoped>
.title {
  font-size: clamp(18px, 5vw, 25px);
  font-weight: bold;
  color: gray;
  word-break: break-word;
}

.buttons-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 16px;
  padding: 16px;
  width: 100%;
}

.action-button {
  min-width: 120px !important;
  height: 40px !important;
  flex: 1 1 120px;
}

@media (max-width: 600px) {
  .buttons-container {
    flex-direction: column;
    padding: 16px;
  }

  .action-button {
    width: 100% !important;
    margin: 0 !important;
  }

  .v-btn {
    margin: 0 !important;
  }
}
</style>
